import { RequiredGps } from '../../../components/Errors';
import { BottomSheet } from 'react-spring-bottom-sheet';

const Index = (props) => {
	const { isShowGpsSheet, onClose: onCloseGpsGuard } = props;

	return (
		<>
			<BottomSheet key={'gps-required'} open={isShowGpsSheet} onDismiss={onCloseGpsGuard}>
				<RequiredGps {...props} />
			</BottomSheet>
		</>
	);
};

export default Index;
